import { useLanguage } from "@web/lib/contexts/language-context"
import { Card, CardContent, CardHeader, CardTitle } from "@web/components/ui/card"
import { Separator } from "@web/components/ui/separator"

export default function PrivacyPolicyPage() {
  const { t } = useLanguage()
  const pp = t.privacyPolicyPage

  return (
    <main className="min-h-screen bg-background">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl font-bold text-foreground sm:text-3xl">
              {pp.title}
            </CardTitle>
            <p className="mt-2 text-lg text-muted-foreground">
              {pp.company}
            </p>
          </CardHeader>

          <CardContent className="space-y-8">
            <section className="space-y-4">
              <p className="text-foreground leading-relaxed">{pp.introP1}</p>
              <p className="text-foreground leading-relaxed">{pp.introP2}</p>
              <p className="text-foreground leading-relaxed">{pp.introP3}</p>
              <p className="text-foreground leading-relaxed">{pp.introP4}</p>
              <p className="text-foreground leading-relaxed">{pp.introP5}</p>
              <p className="text-foreground leading-relaxed">{pp.introP6}</p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section1.title}</h2>
              <p className="text-foreground leading-relaxed">{pp.section1.p1}</p>
              <p className="text-foreground leading-relaxed">{pp.section1.p2}</p>
              <p className="text-foreground leading-relaxed">{pp.section1.p3}</p>
              <p className="text-foreground leading-relaxed">{pp.section1.p4}</p>
              <p className="text-foreground leading-relaxed">{pp.section1.p5}</p>
              <p className="text-foreground leading-relaxed">{pp.section1.p6}</p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section2.title}</h2>
              <p className="text-foreground leading-relaxed">{pp.section2.p1}</p>
              <p className="text-foreground leading-relaxed">{pp.section2.p2}</p>
              <p className="text-foreground leading-relaxed">{pp.section2.p3}</p>
              <p className="text-foreground leading-relaxed">{pp.section2.p4}</p>
              <p className="text-foreground leading-relaxed">{pp.section2.p5}</p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section3.title}</h2>
              <p className="text-foreground leading-relaxed">{pp.section3.p1}</p>
              <ul className="list-disc pl-6 space-y-3 text-foreground leading-relaxed">
                {pp.section3.list.map((item, index) => (
                  <li key={index}>
                    <strong>{item.label}</strong> {item.text}
                  </li>
                ))}
              </ul>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section4.title}</h2>
              <p className="text-foreground leading-relaxed">{pp.section4.p1}</p>
              <p className="text-foreground leading-relaxed">{pp.section4.p2}</p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section5.title}</h2>
              <p className="text-foreground leading-relaxed">{pp.section5.p1}</p>
              <p className="text-foreground leading-relaxed">{pp.section5.p2}</p>
              <p className="text-foreground leading-relaxed">{pp.section5.p3}</p>
              <p className="text-foreground leading-relaxed">{pp.section5.p4}</p>
              <p className="text-foreground leading-relaxed">{pp.section5.p5}</p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section6.title}</h2>
              <p className="text-foreground leading-relaxed">{pp.section6.p1}</p>
              <p className="text-foreground leading-relaxed">
                {pp.section6.p2}{" "}
                <a
                  href={`mailto:${pp.section6.email}`}
                  className="text-primary underline hover:text-primary/80"
                >
                  {pp.section6.email}
                </a>
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">{pp.section7.title}</h2>
              <p className="text-foreground leading-relaxed">
                {pp.section7.p1}{" "}
                <a
                  href={pp.section7.link}
                  className="text-primary underline hover:text-primary/80"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {pp.section7.link}
                </a>
                .
              </p>
            </section>

            <div className="pt-8 text-center text-sm text-muted-foreground">
              <p>{pp.copyright.replace("{year}", String(new Date().getFullYear()))}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </main>
  )
}
